import React, { useState, useEffect, useRef, Fragment } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import FlagWrapper from '../Wrappers/LibWrappers/FlagWrapper';

import { NAV_LINKS } from './navLinks';
import API from 'API';

import { GLOBAL_SETTINGS_URLS } from 'shared/urlList';
import { useClickOutside } from 'shared/utility';
import { getGuestUserLS } from 'shared/localStorage';
import { getGameWsUser, getNotificationList } from 'store/gameWs/selector';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import { ReactComponent as Settings } from 'assets/icons/settings.svg';
import { ReactComponent as Bug } from 'assets/icons/bug_icon.svg';
import { ReactComponent as Notification } from 'assets/icons/icon_notification-icon_notification_16@2x.svg';
import { ReactComponent as Logo } from 'assets/icons/logo_2@2x.svg';
import { ReactComponent as Menu } from 'assets/icons/menu_icon.svg';
import { ReactComponent as Close } from 'assets/icons/close_icon.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow_down_bold.svg';
import defaultUser from 'assets/images/egg_avatar.png';

import WithRegisterModal from 'components/Wrappers/WithRegisterModal/WithRegisterModal';

import PlayerTitle from 'UI/PlayerTitle/PlayerTitle';
import ProfileMenu from 'UI/ProfileMenu/ProfileMenu';
import SwissKnifeMenu from 'UI/SwissKnifeMenu/SwissKnifeMenu';
import PrimaryButtonLink from 'UI/PrimaryButtonLink/PrimaryButtonLink';
import Search from './Search/Search';
import NotificationCenter from 'UI/NotificationCenter/NotificationCenter';

import styles from './Header.module.scss';

const Header = ({ user, openMenu, showRegisterModal }) => {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [guest, setGuest] = useState(JSON.parse(getGuestUserLS()));
    const [showMenu, setShowMenu] = useState(openMenu);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationPanel, setNotificationPanel] = useState([]);
    const [countNotify, setCountNotify] = useState(0);
    const notificationCounter = useSelector(getNotificationList, shallowEqual);
    const guestWs = useSelector(getGameWsUser, shallowEqual);

    const ref = useRef();
    const searchRef = useRef();
    const notificationRef = useRef();

    const videoRegex = /^\/videos\/[0-9]+$/;
    const programRegex = /^\/program\/[0-9]+$/;
    const programsRegex = /^\/program\/chapter\/[0-9]+$/;
    const masterclassRegex = /^\/masterclass\/chapter\/[0-9]+$/;

    const handleModal = () => {
        setShow(!show);
    };

    const handleBigMenu = () => {
        setShowMenu(!showMenu);
    };

    const toggleSearch = () => {
        setOpen(!open);
    };

    const openUsersnap = () => {
        window.Usersnap.open();
    };

    const openNotifications = async () => {
        try {
            await API.post('/notifications/read_all', {});
            setShowNotification(!showNotification);
            setCountNotify(0);
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
    };

    const fetchNotifications = async () => {
        try {
            const resp = await API.get('/notifications');
            const { data } = resp.data;
            setNotificationPanel(data);
            // setCountNotify(counter);
        } catch (error) {
            // eslint-disable-next-line
            console.log(error);
        }
    };

    const clearAllNotifications = async () => {
        try {
            await API.post('/notifications/clear_all', {});
            fetchNotifications();
        } catch (error) {
            // eslint-disable-next-line
            console.log(error);
        }
        setShowNotification(false);
    };

    const lockNavigation = (e) => {
        e.preventDefault();
        showRegisterModal();
    };

    useEffect(() => {
        let counter = 0;

        for (const data of notificationPanel) {
            if (data.read === false) {
                counter += 1;
            }
        }
        setCountNotify(counter);
    }, [notificationPanel]);

    useEffect(() => {
        if (showMenu) {
            document.body.style.overflow = 'hidden';
        }

        return () => (document.body.style.overflow = 'unset');
    }, [showMenu]);

    useEffect(() => {
        !guest && !user && setGuest(JSON.parse(getGuestUserLS()));
    }, [user]);

    useEffect(() => {
        open && searchRef.current.focus();
    }, [open]);

    useClickOutside(ref, handleModal);
    useClickOutside(notificationRef, openNotifications);

    useEffect(() => {
        if (user) {
            fetchNotifications();
        }
    }, [notificationCounter]);

    return (
        <Fragment>
            <Search
                user={user}
                open={open}
                ref={searchRef}
                showRegisterModal={showRegisterModal}
                toggleSearch={toggleSearch}
            />
            <header className={styles.header} id="navbar">
                <section className={styles.left}>
                    <Link
                        to="/home"
                        id="logo_small"
                        className={styles.logo_small}
                    >
                        <Logo className={styles.logo_small} />
                    </Link>
                    <Link to="/home" id="logo" className={styles.logo_2}>
                        <Logo className={styles.logo} />
                    </Link>
                    <div
                        className={styles.user}
                        onClick={handleModal}
                        style={{ cursor: user ? 'pointer' : 'initial' }}
                    >
                        <div>
                            {user && user.avatar ? (
                                <img
                                    src={
                                        user.avatar.src ||
                                        require(`assets/icons/skill_levels/${user.level ||
                                            user.skill_level}.png`)
                                    }
                                    alt={user.username}
                                    className={styles.avatar}
                                />
                            ) : (
                                <img
                                    src={defaultUser}
                                    alt="user default"
                                    className={styles.avatar}
                                />
                            )}
                            {user && (
                                <PlayerTitle
                                    title={user.level || user.skill_level}
                                    width={39}
                                />
                            )}
                        </div>
                        <div className={styles.username_rating}>
                            <div id="user_name" className={styles.user_name}>
                                <h4>
                                    {(user && user.username) ||
                                        `K-chess ${(guestWs &&
                                            guestWs.username) ||
                                            (guest && guest.username)}`}
                                    {user && (
                                        <div className={styles.arrow_down}>
                                            <ArrowDown />
                                        </div>
                                    )}
                                </h4>
                            </div>
                            <div id="urs" className={user ? styles.urs : null}>
                                {user && user.country && (
                                    <FlagWrapper
                                        countryCode={user.country}
                                        size={'16px'}
                                    />
                                )}
                                {user && (
                                    <span> • {user && user.ks_rating}</span>
                                )}
                            </div>
                        </div>
                        {show && user ? (
                            <div className={styles.bla} ref={ref}>
                                <ProfileMenu user={user} />
                            </div>
                        ) : null}
                    </div>
                </section>
                <section className={styles.middle}>
                    {!showMenu && (
                        <nav>
                            <ul>
                                {NAV_LINKS.map((el) => {
                                    return (
                                        <li key={el.intl_id}>
                                            <NavLink
                                                exact
                                                to={el.link}
                                                activeClassName={
                                                    styles.link_active
                                                }
                                                isActive={(match, location) => {
                                                    if (el.isPlay) {
                                                        return (
                                                            location.pathname ===
                                                                '/play-online-chess' ||
                                                            location.pathname ===
                                                                '/correspondence-games'
                                                        );
                                                    }

                                                    if (el.isWatch) {
                                                        return (
                                                            location.pathname ===
                                                                '/watch' ||
                                                            videoRegex.test(
                                                                location.pathname
                                                            ) ||
                                                            location.pathname ===
                                                                '/chess-journeys' ||
                                                            location.pathname ===
                                                                '/documentaries' ||
                                                            location.pathname ===
                                                                '/interviews-and-podcasts' ||
                                                            location.pathname ===
                                                                '/videos'
                                                        );
                                                    }

                                                    if (el.isResults) {
                                                        return (
                                                            location.pathname ===
                                                                '/results' ||
                                                            location.pathname ===
                                                                '/global-ranking'
                                                        );
                                                    }

                                                    if (el.isLearn) {
                                                        return (
                                                            location.pathname ===
                                                                '/learn' ||
                                                            location.pathname ===
                                                                '/programs' ||
                                                            masterclassRegex.test(
                                                                location.pathname
                                                            ) ||
                                                            programRegex.test(
                                                                location.pathname
                                                            ) ||
                                                            programsRegex.test(
                                                                location.pathname
                                                            ) ||
                                                            location.pathname ===
                                                                '/masterclass'
                                                        );
                                                    }

                                                    if (el.isGCT) {
                                                        return (
                                                            location.pathname ===
                                                            '/grand-chess-tour'
                                                        );
                                                    }
                                                    if (el.isLegacy) {
                                                        return (
                                                            location.pathname ===
                                                            '/legacy'
                                                        );
                                                    }
                                                }}
                                            >
                                                <FormattedMessage
                                                    id={el.intl_id}
                                                />
                                                {/* {el.isPlay && <sup>BETA</sup>} */}
                                            </NavLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        </nav>
                    )}
                </section>
                <section className={styles.right}>
                    <nav>
                        {user && !showMenu && (
                            <ul>
                                {/* <li>Shop.</li> */}
                                {user.user_tier === 'free' &&
                                    (!user.subscription ||
                                        (user.subscription.status &&
                                            (user.subscription.status ===
                                                'expired' ||
                                                user.subscription.status ===
                                                    'canceled'))) && (
                                        <li>
                                            <Link to="/upgrade-account">
                                                Become Pro
                                            </Link>
                                        </li>
                                    )}
                            </ul>
                        )}
                        <section className={styles.actions_section}>
                            {user ? (
                                <Fragment>
                                    <div className={styles.notification}>
                                        <Bug onClick={openUsersnap} />
                                    </div>
                                    <div className={styles.settings}>
                                        <Link
                                            to={
                                                GLOBAL_SETTINGS_URLS.BOARD_AND_PIECES
                                            }
                                        >
                                            <Settings />
                                        </Link>
                                    </div>
                                    <div
                                        className={styles.notification}
                                        onClick={openNotifications}
                                    >
                                        {countNotify !== 0 && (
                                            <div
                                                className={
                                                    styles.notification_counter
                                                }
                                            >
                                                {countNotify}
                                            </div>
                                        )}
                                        <Notification />
                                    </div>
                                    {showNotification && (
                                        <div ref={notificationRef}>
                                            <NotificationCenter
                                                notifications={
                                                    notificationPanel
                                                }
                                                clearNotifications={
                                                    clearAllNotifications
                                                }
                                                show={showNotification}
                                            />
                                        </div>
                                    )}
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Link
                                        to="/login"
                                        style={{ marginRight: '24px' }}
                                    >
                                        Log in
                                    </Link>
                                    <PrimaryButtonLink
                                        to="/onboarding"
                                        style={{
                                            width: 'auto',
                                            height: '42px',
                                            marginRight: '24px',
                                        }}
                                    >
                                        Sign up for free
                                    </PrimaryButtonLink>
                                </Fragment>
                            )}
                            <div className={styles.search}>
                                <SearchIcon onClick={toggleSearch} />
                            </div>
                            <div
                                className={styles.menu}
                                onClick={handleBigMenu}
                            >
                                {showMenu ? <Close /> : <Menu />}
                            </div>
                        </section>
                    </nav>
                </section>
            </header>
            <SwissKnifeMenu showMenu={showMenu} closeMenu={handleBigMenu} />
        </Fragment>
    );
};

export default WithRegisterModal(Header);
